import React, { useEffect } from "react";

import Loader from "../components/Loader";

import { connect } from "react-redux";

import {
  getPromotionPageFeatured,
  getPromotionPageDefault,
} from "../redux/actions/promotions";
import { setSubRoute } from "../redux/actions/navigation";

import FeaturedPromotionForm from "../components/PromotionsContent/FeaturedPromotionForm";
import DefaultPromotionForm from "../components/PromotionsContent/DefaultPromotionForm";
import ListPageHeader from "../components/Shared/ListPageHeader";
import PageTabs from "../components/Shared/PageTabs";

import styles from '../styles/pages/FeaturedContentPages/PromotionPageContent.module.css'

const PromotionsPageContent = ({
  getPromotionPageFeatured,
  getPromotionPageDefault,
  setSubRoute,
  promotion: { isLoading },
  navigation: { subRoute },
}) => {

  useEffect(() => {
    if (!subRoute || !subRoute.startsWith('promotion-listing')) {
      setSubRoute('promotion-listing-featured-promotion')
    }
  }, [subRoute])

  useEffect(() => {
    getPromotionPageFeatured();
    getPromotionPageDefault();
  }, [getPromotionPageFeatured, getPromotionPageDefault]);

  const tabs = [
    {name: 'Featured Promotions', subRoute: 'promotion-listing-featured-promotion'},
    {name: 'Default Promotions', subRoute: 'promotion-listing-default-promotion'},
  ]

  const handleChangeTab = (tab) => {
    setSubRoute(tab)
  }

  return isLoading ? (
    <Loader />
  ) : (
    <div>
      <ListPageHeader
          title={'Promotion Listing Page Featured Content'}
          description={'Browse and manage all featured content for the Dental Product Shopper promotion list page.  This page lets you add, edit, or remove featured content.'}
         
          subComponent={
            <PageTabs 
              tabs={tabs} 
              selectedTab={subRoute} 
              handleChangeTab={handleChangeTab} 
              desktopStyles={styles.page_tab_desktop}
              mobileStyles={styles.mobile_tab_desktop}
              mobileDropdownLabel={'Select Section'}
              />
          }
          
      />
     
      {subRoute === 'promotion-listing-featured-promotion' ? (
        <FeaturedPromotionForm />
      ) : subRoute === 'promotion-listing-default-promotion' ? (
        <DefaultPromotionForm />
      ) : null}
      
    </div>
  );
};

const mapStateToProps = (state) => ({
  promotion: state.promotion,
  navigation: state.navigation,
});

export default connect(mapStateToProps, {
  getPromotionPageFeatured,
  getPromotionPageDefault,
  setSubRoute,
})(PromotionsPageContent);
